import { useCallback, useState } from 'react';
import { auth } from '../auth/firebaseAuth';
import { createSubscriptionCheckout } from '../api/stripeService';
import { SUBSCRIPTION_TIER_IDS } from '../constants/subscriptionTiers';
import { setCheckoutIntent, setOpenCreateGroupAfterCheckout } from '../utils/checkoutIntent';
import { CHECKOUT_INTENTS } from '../constants/checkoutAttribution';

/**
 * Start LockedIn Plus checkout with optional source attribution.
 * @param {{ source?: string, detail?: string, intent?: string, openCreateGroup?: boolean }} opts
 */
export function usePlusCheckout({ onError, onRedirect } = {}) {
  const [loading, setLoading] = useState(false);

  const startPlusCheckout = useCallback(async ({
    source,
    detail,
    intent,
    openCreateGroup = false,
  } = {}) => {
    const user = auth.currentUser;
    if (!user?.uid) {
      onError?.('Sign in to start LockedIn Plus.');
      return;
    }
    if (openCreateGroup || intent === CHECKOUT_INTENTS.CREATE_LEAGUE) {
      setOpenCreateGroupAfterCheckout();
    } else if (intent) {
      setCheckoutIntent(intent);
    }
    setLoading(true);
    try {
      const tierId = SUBSCRIPTION_TIER_IDS.PLUS;
      const { url } = await createSubscriptionCheckout(tierId, {
        userId: user.uid,
        email: user.email,
        checkoutSource: source,
        checkoutDetail: detail,
      });
      if (url) {
        onRedirect?.();
        window.location.href = url;
      }
    } catch (err) {
      onError?.(err?.message || 'Could not start checkout.');
    } finally {
      setLoading(false);
    }
  }, [onError, onRedirect]);

  return { startPlusCheckout, checkoutLoading: loading };
}
